module.exports = __webpack_public_path__ + "static/img/EnglandIcon.21a5a9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Menu/EnglandIcon.svg
// module id = 2Wx8
// module chunks = 0